module.exports = require("inspector");;